import { PathCondition } from './settings';

export interface ElementDisablerSettings {
    ElementDisabler: {
        agentAssistButtonsDisableWhen: PathCondition<unknown>[];
        callToActionDisableWhen: PathCondition<unknown>[];
        displayLinkDisableWhen: PathCondition<unknown>[];
        displayLinkFoldDisableWhen: PathCondition<unknown>[];
        headerButtonsDisableWhen: PathCondition<unknown>[];
        inlineSurveyButtonDisableWhen: PathCondition<unknown>[];
        inputBoxDisableWhen: PathCondition<unknown>[];
        inputSubmitButtonDisableWhen: PathCondition<unknown>[];
        minimizeButtonDisableWhen: PathCondition<unknown>[];
        navigationLinksDisableWhen: PathCondition<unknown>[];
        responseMessageDisableWhen: PathCondition<unknown>[];
        skipToContentButtonDisableWhen: PathCondition<unknown>[];
        windowFormDisableWhen: PathCondition<unknown>[];
    };
}

export default {
    ElementDisabler: {
        agentAssistButtonsDisableWhen: [

        ],
        callToActionDisableWhen: [
            {
                statePath: "Window.TimeoutWarning.visible",
                operator: "equal",
                value: true,
            },
        ],
        displayLinkDisableWhen: [
            {
                statePath: "Window.TimeoutWarning.visible",
                operator: "equal",
                value: true,
            },
        ],
        displayLinkFoldDisableWhen: [
            {
                statePath: "Window.TimeoutWarning.visible",
                operator: "equal",
                value: true,
            },
        ],
        headerButtonsDisableWhen: [

        ],
        inlineSurveyButtonDisableWhen: [
            {
                statePath: "Window.TimeoutWarning.visible",
                operator: "equal",
                value: true,
            },
        ],
        inputBoxDisableWhen: [
            {
                statePath: "Window.TimeoutWarning.visible",
                operator: "equal",
                value: true,
            },
        ],
        inputSubmitButtonDisableWhen: [
            {
                statePath: "Window.TimeoutWarning.visible",
                operator: "equal",
                value: true,
            },
        ],
        minimizeButtonDisableWhen: [
        ],
        navigationLinksDisableWhen: [
            {
                statePath: "Window.TimeoutWarning.visible",
                operator: "equal",
                value: true,
            },
        ],
        responseMessageDisableWhen: [
            {
                statePath: "Window.TimeoutWarning.visible",
                operator: "equal",
                value: true,
            },
        ],
        skipToContentButtonDisableWhen: [
            {
                statePath: "Window.TimeoutWarning.visible",
                operator: "equal",
                value: true,
            },
        ],
        windowFormDisableWhen: [
            {
                statePath: "Window.TimeoutWarning.visible",
                operator: "equal",
                value: true,
            },
        ],
    },
} as ElementDisablerSettings;



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/element-disabler.ts